export default "__VITE_ASSET__26d3ff72__"